import React, {Component} from 'react';
import { translate, Trans } from "react-i18next";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import {required,email,isValidForm} from '../../server/validationMethods.js';
import {IncomFreqency,IncomType} from '../Parent/SchoolLunchBreakfastProgram/schoolLunchBreakfastModal';
import Draft from './draft.js';
class AddAdultIncome extends Component {
    constructor(props){
        super(props);
        this.state={
            'hasError':false,
            'hasRequiredError':false
        }
        this.validateFields=this.validateFields.bind(this)
        this.childComponentRef = React.createRef();
    }
    validateFields=()=>{
        let parentError=true;
        parentError=this.props.lunchObj.persons.every((parent,s)=>{
            return parent.income.every((inc)=>{
                return inc.source!='' && inc.frequency!='' && parseFloat(inc.amount===''?0:inc.amount)>0
            })
        });
        let otherError=true
        otherError= this.props.lunchObj.adultList.every((adult,s)=>{
            return adult.income.every((inc)=>{
                return inc.source!='' && inc.frequency!='' && parseFloat(inc.amount===''?0:inc.amount)>0
            })
        })

        if(parentError && otherError ){
            return true
        }
        return false
    }
    validateRequiredIncomeInfo=()=>{
        let count=0;
        this.props.lunchObj.persons.map((parent,s)=>{
            count=count+ (parent.income||[]).length
        });
        this.props.lunchObj.adultList.map((parent,s)=>{
            count=count+ (parent.income||[]).length
        });
        if(count>0){
            return true
        }
        return false;
    }
render(){
   return(
        <div>
            <div className="row">
                <div className="col-xs-12 block">
                    <div className="schoolInfo">
                        <p><Trans>This page is all about parent</Trans></p>
                        <p><Trans>On questions about income, all amounts should be parent’s current, gross income</Trans>.</p>
                        <p><Trans>Gross income means all money earned or received before deductions such as income taxes, social security taxes, and insurance premiums</Trans>. <Trans>You should not report net income, which is the amount of money received in a pay check</Trans>.</p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <div className="row">
                    {
                    this.props.lunchObj.persons.map((adult,s)=>{                       
                            return(
                                <div className="row">
                                    <div className="col-md-9">
                                        <h5 className="color-5"><strong>{adult.lname+' '+adult.fname}</strong></h5>
                                    </div>
                                    {
                                        adult.income.length<3?
                                        <div className="col-md-2">
                                    <button type="button" className="btn-social btn-twitter-link" data-midx={s} style={{margin:'0px'}} onClick={(e)=>{
                                        let midx=e.target.getAttribute('data-midx');
                                        this.props.addIncome(midx,'persons')
                                        this.childComponentRef.current.formatDraftReqObj();
                                    }}><i className="fa fa-plus"></i> <Trans>Add income</Trans></button>
                                    </div>:null

                                    }
                                    
                                    <div className="col-md-12" style={{paddingLeft:'30px'}}>                                        
                                        {
                                            adult.income.map((inc,i)=>{
                                                return (<div className="row">
                                                    <div className="col-md-4" style={{paddingBottom:'10px'}}>
                                                    <select className="form-control" name={'source-stu-'+s+'-'+i} data-fname={'source'} data-midx={s} data-sidx={i} 
                                                    value={inc.source}
                                                    onChange={(e)=>{
                                                        let midx=e.target.getAttribute('data-midx');
                                                        let sidx=e.target.getAttribute('data-sidx');
                                                        this.props.onFieldValueChange(midx,'persons',sidx,e.target.getAttribute('data-fname'),e.target.value);
                                                    }} >
                                                        <option></option>
                                                        {
                                                            (() => {
                                                            const selectedSources = adult.income
                                                            .map(v => v.source)
                                                            .filter(src => src !== '');

                                                        return IncomType.map((incType, t) => {
                                                            const isDisabled =
                                                                selectedSources.includes(incType) && incType !== inc.source;

                                                            return (
                                                                <option key={t} value={incType} disabled={isDisabled}>
                                                                    <Trans>{incType}</Trans>
                                                                </option>
                                                            );
                                                        });
                                                    })()
                                                }
                                                    </select>
                                                    </div>
                                                    <div className="col-md-2" style={{paddingBottom:'10px'}}>
                                                    <select className="form-control" name={'frequency-stu-'+s+'-'+i} data-fname={'frequency'} data-midx={s} 
                                                     data-sidx={i} value={inc.frequency} onChange={(e)=>{
                                                        let midx=e.target.getAttribute('data-midx');
                                                        let sidx=e.target.getAttribute('data-sidx');
                                                        this.props.onFieldValueChange(midx,'persons',sidx,e.target.getAttribute('data-fname'),e.target.value);
                                                    }} >
                                                        <option></option>
                                                        {                                                            
                                                            IncomFreqency.map((freq,f)=>{
                                                                return <option key={f} value={freq.value}><Trans>{freq.text}</Trans></option>
                                                            })
                                                        }
                                                    </select></div>
                                                    <div className="col-md-2">
                                                    <input className="form-control" name={'amount-stu-'+s+'-'+i} data-fname={'amount'} data-midx={s} data-sidx={i}
                                                    type="number" value={inc.amount} onChange={(e)=>{
                                                        let midx=e.target.getAttribute('data-midx');
                                                        let sidx=e.target.getAttribute('data-sidx');
                                                        this.props.onFieldValueChange(midx,'persons',sidx,e.target.getAttribute('data-fname'),e.target.value);
                                                    }} />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <button type="button" data-midx={s} data-sidx={i} 
                                                        className="btn-social btn-twitter-link color-1" style={{margin:'0px'}} onClick={(e)=>{
                                                            let midx=e.target.getAttribute('data-midx');
                                                            let sidx=e.target.getAttribute('data-sidx');
                                                            this.props.onDeleteIncome(midx,'persons',sidx);
                                                            this.childComponentRef.current.formatDraftReqObj();
                                                        }}><i className="fa fa-trash"></i> <Trans>Delete</Trans></button>
                                                    </div>
                                                </div>)
                                            })
                                        }
                                    </div>
                                </div>
                            )
                    })
                }
                    {
                    this.props.lunchObj.adultList.map((adult,s)=>{                        
                            return(
                                <div className="row">
                                    <div className="col-md-9">
                                        <h5 className="color-5"><strong>{adult.lname+' '+adult.fname}</strong></h5>
                                    </div>
                                    {
                                        adult.income.length<3?
                                        <div className="col-md-2">
                                    <button type="button" className="btn-social btn-twitter-link" data-midx={s} style={{margin:'0px'}} onClick={(e)=>{
                                        let midx=e.target.getAttribute('data-midx');
                                        this.props.addIncome(midx,'adultList')
                                        this.childComponentRef.current.formatDraftReqObj();
                                    }}><i className="fa fa-plus"></i> <Trans>Add income</Trans></button>
                                    </div>:null
                                    }
                                    
                                    <div className="col-md-12" style={{paddingLeft:'30px'}}>                                        
                                        {
                                            adult.income.map((inc,i)=>{
                                                return (<div className="row">
                                                    <div className="col-md-4" style={{paddingBottom:'10px'}}>
                                                    <select className="form-control" name={'source-stu-'+s+'-'+i} data-fname={'source'} data-midx={s} data-sidx={i} 
                                                    value={inc.source}
                                                    onChange={(e)=>{
                                                        let midx=e.target.getAttribute('data-midx');
                                                        let sidx=e.target.getAttribute('data-sidx');
                                                        this.props.onFieldValueChange(midx,'adultList',sidx,e.target.getAttribute('data-fname'),e.target.value);
                                                    }} >
                                                        <option></option>
                                                         {
                                                                (() => {
                                                                const selectedSources = adult.income
                                                                .map(v => v.source)
                                                                .filter(src => src !== '');

                                                            return IncomType.map((incType, t) => {
                                                                const isDisabled =
                                                                    selectedSources.includes(incType) && incType !== inc.source;

                                                                return (
                                                                    <option key={t} value={incType} disabled={isDisabled}>
                                                                        <Trans>{incType}</Trans>
                                                                    </option>
                                                                );
                                                            });
                                                        })()
                                                    }
                                                    </select>
                                                    </div>
                                                    <div className="col-md-2" style={{paddingBottom:'10px'}}>
                                                    <select className="form-control" name={'frequency-stu-'+s+'-'+i} data-fname={'frequency'} data-midx={s} 
                                                     data-sidx={i} value={inc.frequency} onChange={(e)=>{
                                                        let midx=e.target.getAttribute('data-midx');
                                                        let sidx=e.target.getAttribute('data-sidx');
                                                        this.props.onFieldValueChange(midx,'adultList',sidx,e.target.getAttribute('data-fname'),e.target.value);
                                                    }} >
                                                        <option></option>
                                                        {                                                            
                                                            IncomFreqency.map((freq,f)=>{
                                                                return <option key={f} value={freq.value}>{freq.text}</option>
                                                            })
                                                        }
                                                    </select></div>
                                                    <div className="col-md-2">
                                                    <input className="form-control" name={'amount-stu-'+s+'-'+i} data-fname={'amount'} data-midx={s} data-sidx={i}
                                                    type="number" value={inc.amount} onChange={(e)=>{
                                                        let midx=e.target.getAttribute('data-midx');
                                                        let sidx=e.target.getAttribute('data-sidx');
                                                        this.props.onFieldValueChange(midx,'adultList',sidx,e.target.getAttribute('data-fname'),e.target.value);
                                                    }} />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <button type="button" data-midx={s} data-sidx={i} 
                                                        className="btn-social btn-twitter-link color-1" style={{margin:'0px'}} onClick={(e)=>{
                                                            let midx=e.target.getAttribute('data-midx');
                                                            let sidx=e.target.getAttribute('data-sidx');
                                                            this.props.onDeleteIncome(midx,'adultList',sidx);
                                                            this.childComponentRef.current.formatDraftReqObj();
                                                        }}><i className="fa fa-trash"></i> <Trans>Delete</Trans></button>
                                                    </div>
                                                </div>)
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        
                    })
                }
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <p>
                    { (!this.validateFields()) && this.state.hasError? <span className="text-danger"> <Trans>Please enter all required information above</Trans>.</span>:null
                    }
                    {
                       (!this.validateRequiredIncomeInfo()) && this.state.hasRequiredError?<span className="text-danger"><Trans>Please report at least one adult income to continue</Trans>.</span>:null
                    }
                    </p>
                </div>
            </div> 
            <div className="row">
                <div className="col-xs-12">
                        <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                        this.props.jumpToStep(10)
                    }}>
                        <Trans>Previous</Trans>
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{
                        if(this.validateFields()){
                            if(!this.validateRequiredIncomeInfo()){
                                this.setState({hasRequiredError:true})
                            }else{
                                this.props.jumpToStep(12);
                            }
                            
                        }else{
                            this.setState({hasError:true})
                        }
                        
                    }}><Trans>Continue</Trans>
                    </button>
                    <Draft lunchObj={this.props.lunchObj} schoolInfo={this.props.schoolInfo} ref={this.childComponentRef} />
                </div>
            </div>
        </div>
    )
}
}
export default AddAdultIncome;


// WEBPACK FOOTER //
// ./src/components/FreeReducedProgram/addAdultIncome.jsx